import { fetchAuthSession, fetchUserAttributes } from "aws-amplify/auth";
import { CognitoAccountGroup, userGroupFromTokenPayload } from "@/js/tierconfig";
import { monitoringForgetUser, monitoringIdentifyUser } from "./monitoring";
import posthog from "posthog-js";

export async function identifyAnalyticsUser() {
	try {
		const attributes = await fetchUserAttributes();
		const session = await fetchAuthSession();

		const userID = attributes?.["custom:user_id"] ?? "";
		const groups = session.tokens?.accessToken?.payload?.["cognito:groups"] as string[] | undefined;
		// TODO: Fix
		const userTier = userGroupFromTokenPayload(groups as CognitoAccountGroup[]);

		if (userID) {
			const email = attributes?.email;
			// Use "signaloid" for internal addresses so Signaloid employees can be
			// filtered out in PostHog analytics. Non-internal emails are omitted.
			const posthogEmail = email?.includes("@signaloid.com") ? "signaloid" : undefined;
			posthog?.identify(userID, {
				email: posthogEmail,
				userTier: userTier,
			});

			if (userTier) {
				posthog?.group("tier", userTier);
			}

			monitoringIdentifyUser(userID);
		}
	} catch (error) {
		console.warn("identifyAnalyticsUser failed:", error);
	}
}

export async function forgetAnalyticsUser() {
	globalThis.analytics?.reset();
	posthog?.reset();
	monitoringForgetUser();
}
